export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./register.vue?vue&type=template&id=440492f7&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/views/authen/register.vue?vue&type=template&id=440492f7&scoped=true&
// module id = 738
// module chunks = 1